import noUiSlider from 'nouislider'

let currentSliderSteps
let slider
const rangeSlider = document.getElementById('slider-range')

const addComma = function(number)
{
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * Callback for the slider move event
 *
 * @param values
 */
const onSliderMove = function(values)
{
    const value = parseFloat(values[0])
    const product = currentSliderSteps.references[value]

    updateBubbles(product)
    updateProductTotal(product)
}

/**
 * Create or update the slider instance
 *
 * @param sliderSteps
 */
const createOrUpdateSlider = function(sliderSteps = null)
{
    // Stop if no slider found
    if (!rangeSlider) {
        return
    }

    // Prepare the slider options
    const sliderOptions = {
        start: sliderSteps.range.min,
        connect: 'lower',
        snap: true,
        range: sliderSteps.range
    }

    // Store the slider steps
    currentSliderSteps = sliderSteps

    if (slider) {
        slider.updateOptions(sliderOptions, true)
    } else {
        sliderOptions.start = parseInt(window.activeProduct.title.split(' ')[0])
        slider = noUiSlider.create(rangeSlider, sliderOptions)
        slider.on('slide', onSliderMove)
    }
}

/**
 * Return the slider steps
 *
 * @param products
 * @param categoryId
 */
const getSliderSteps = function(products, categoryId)
{
    // For storing the processed data
    const data = {steps: [], references: {}, range: {}, firstProduct: {}, title: null}

    let counter = 0

    products.forEach((product, index) => {
        // Move of if the category doesn't match
        if (product.product_category_id !== parseInt(categoryId)) {
            return
        }

        const titleParts = product.title.split(' ')

        // If the first item
        if (counter === 0) {
            data.firstProduct = product
            data.title = product.title
        }

        data.steps.push({
            id: product.product_id,
            title: product.title,
            price: product.price,
            base_price: product.base_price,
            quantity: parseInt(titleParts[0]),
            real_quantity: titleParts[0],
            comment: product.comment
        })

        counter++
    })

    const flat = data.steps.length
    const step = 100 / (flat - 1)

    for (let i = 0; i < flat; i++) {
        data.references[data.steps[i].quantity] = data.steps[i]

        let key = (i * step).toFixed(2) + '%'

        if (i === 0) {
            key = 'min'
        }

        if (i === flat - 1) {
            key = 'max'
        }

        data.range[key] = data.steps[i].quantity
    }

    return data
}

const formatTitle = function(title)
{
    const titleArray = title.split(' ')

    if (parseInt(titleArray[0]) < 1000) {
        return title;
    }

    let num = parseInt(titleArray[0]).toLocaleString()

    titleArray.shift()

    return num + ' ' + titleArray.join(' ')
}

/**
 * Update the order total
 *
 * @param product
 */
const updateProductTotal = function(product)
{
    const $actionCard = $('#summary-wrap')
    const $orderSummary = $('.order-summary-wrap', $actionCard)
    const productTitle = formatTitle(product.title)

    // Stop if no order summary
    if ($orderSummary.length === 0) {
        return
    }

    // Update the product title
    $orderSummary.find('.order-summary-order-price .order-summary-description').text(productTitle)

    // Update the price
    $orderSummary.find('.order-summary-order-price .order-summary-sum').text('$' + addComma(product.price))

    let total = product.price

    // If we have a coupon
    if (window.coupon && window.coupon['discount_amount']) {

        // Get the discount amount
        const discountAmount = window.coupon['discount_amount']

        // Calculate the new total
        total = (window.coupon['discount_type'] === 'percentage') ? total - total * discountAmount  : total - discountAmount
    }

    // Update the service key
    if (product.service) {
        $actionCard.find('#order_service').val(product.service.key)
    }

    // Update the product id
    if (product.product_id || product.id) {
        $actionCard.find('#order_product_id').val(product.product_id || product.id)
    }

    // Update the order total
    $orderSummary.find('.order-summary-order-total .order-summary-sum').text('$' + addComma(total))

    // Update the product name
    $orderSummary.find('.order-summary-order-price .order-summary-description').text(productTitle)
}

/**
 * Update product subtotal
 *
 * @param product
 */
const updateBubbles = function(product)
{
    const sliderSteps = getSliderSteps(window.services[window.current_service].products, rangeSlider.getAttribute('data-category'))
    const category = sliderSteps.firstProduct.category.slug

    const bottomBubbleTitleNumber = rangeSlider.querySelector('.noUi-bubble-bottom div p.noUi-bubble-title .number')
    bottomBubbleTitleNumber.innerText = getBottomBubbleQuantity(category, product.real_quantity)

    const bottomBubbleTitleText = rangeSlider.querySelector('.noUi-bubble-bottom div p.noUi-bubble-title .text')
    bottomBubbleTitleText.innerText = getBottomBubbleText(category)

    const bottomBubbleComment = rangeSlider.querySelector('.noUi-bubble-bottom div p.comment')

    setBottomBubbleComment(product, category, bottomBubbleComment)

    const topBubble = rangeSlider.querySelector('.noUi-bubble-top')
    topBubble.innerText = '$' + addComma(product.price)
}

const productComments = function ()
{
    return [
        {
            product: "5 Special Rotating Proxies",
            comment: "200 GB Included Traffic\n$0.60/GB"
        },
        {
            product: "10 Special Rotating Proxies",
            comment: "400 GB Included Traffic\n$0.60/GB"
        },
        {
            product: "25 Special Rotating Proxies",
            comment: "1 TB Included Traffic\n$0.60/GB"
        },
        {
            product: "50 Special Rotating Proxies",
            comment: "2 TB Included Traffic\n$0.60/GB"
        },
        {
            product: "100 Special Rotating Proxies",
            comment: "4 TB Included Traffic\n$0.60/GB"
        },
        {
            product: "250 Special Rotating Proxies",
            comment: "10 TB Included Traffic\n$0.60/GB"
        },
        {
            product: "500 Special Rotating Proxies",
            comment: "20 TB Included Traffic\n$0.60/GB"
        },
        {
            product: "1000 Special Rotating Proxies",
            comment: "40 TB Included Traffic\n$0.60/GB"
        },
        {
            product: "5 Basic Rotating Proxies",
            comment: "200 GB Included Traffic\n$0.30/GB"
        },
        {
            product: "10 Basic Rotating Proxies",
            comment: "400 GB Included Traffic\n$0.30/GB"
        },
        {
            product: "25 Basic Rotating Proxies",
            comment: "1 TB Included Traffic\n$0.30/GB"
        },
        {
            product: "50 Basic Rotating Proxies",
            comment: "2 TB Included Traffic\n$0.30/GB"
        },
        {
            product: "100 Basic Rotating Proxies",
            comment: "4 TB Included Traffic\n$0.30/GB"
        },
        {
            product: "250 Basic Rotating Proxies",
            comment: "10 TB Included Traffic\n$0.30/GB"
        },
        {
            product: "500 Basic Rotating Proxies",
            comment: "20 TB Included Traffic\n$0.30/GB"
        },
        {
            product: "1000 Basic Rotating Proxies",
            comment: "40 TB Included Traffic\n$0.30/GB"
        },
        {
            product: "5 Fast Rotating Proxies",
            comment: "200 GB Included Traffic\n$0.90/GB"
        },
        {
            product: "10 Fast Rotating Proxies",
            comment: "400 GB Included Traffic\n$0.90/GB"
        },
        {
            product: "25 Fast Rotating Proxies",
            comment: "1 TB Included Traffic\n$0.90/GB"
        },
        {
            product: "50 Fast Rotating Proxies",
            comment: "2 TB Included Traffic\n$0.90/GB"
        },
        {
            product: "100 Fast Rotating Proxies",
            comment: "4 TB Included Traffic\n$0.90/GB"
        }
    ]
}

const setBottomBubbleComment = function (product, category, bottomBubbleComment)
{
    switch (category) {
        case 'special-backconnect-proxies':
        case 'basic-backconnect-proxies':
        case 'fast-rotating-special-backconnect-proxies':
            const productComment = productComments().filter((comment) => comment.product === product.title)
            bottomBubbleComment.innerText = productComment.length ? productComment[0].comment : ''
            break
        case 'static-residential-proxies':
        case 'sneakers-proxies':
            bottomBubbleComment.innerText = 'Unlimited traffic'
            break
        case 'webscraping':
            bottomBubbleComment.innerText = product.comment
            break
        default:
            bottomBubbleComment.innerText = ''
    }
}

/**
 * Update the product details card
 *
 * @param serviceId
 * @param categoryId
 */
const updateProductDetails = function(serviceId, categoryId)
{
    const $descriptions = $('.descriptions')
    const stepsData = getSliderSteps(window.services[serviceId]['products'], categoryId)

    updateBubbles(stepsData.references[Object.keys(stepsData.references)[0]])

    // Remove the active description
    $descriptions.find('.description.active').removeClass('active')

    // Show the new description
    $descriptions.find('.description[data-id="' + serviceId + '-' + categoryId + '"]').addClass('active')

    updateProductTotal(stepsData.firstProduct)
}

const makeOrderPricesTabActive = function(orderPrices, categoryId, serviceId)
{
    // Remove the old active order prices tab (category)
    orderPrices.find('.order-prices-tabs .order-prices-tabs-wrap').removeClass('order-prices-active')
    orderPrices.find('.order-prices-tabs .radio-button-description').removeClass('active')
    orderPrices.find('.order-prices-tabs input').removeAttr('checked')

    // Mark order prices tab (category) as active
    const orderPricesTab = orderPrices.find(`.order-prices-tabs-wrap[data-category='${categoryId}']`)
    orderPricesTab.parents().addClass('active')
    orderPricesTab.addClass('order-prices-active')
    orderPricesTab.find('.radio-button-description').addClass('active')
    orderPricesTab.find('input').attr('checked', 'checked')

    const sliderData = getSliderSteps(window.services[serviceId].products, categoryId)

    if (![undefined, null].includes(sliderData.firstProduct.category)) {
        $(`[data-service='${sliderData.firstProduct.category.slug}']`).addClass('active')
    }
}

/**
 * Update the order prices tabs details
 *
 * @param serviceId
 * @param categoryId
 */
const updateOrderPricesTabsDetails = function (serviceId, categoryId)
{
    const orderPrices = $('#order-prices-root')

    // Remove the old active order prices content
    orderPrices.find('.order-prices-tabs.active').removeClass('active')
    orderPrices.find('.order-prices-tab-content').removeClass('active')

    // Mark order prices content as active
    if (serviceId === 'web-hosting') {
        orderPrices.find('.order-prices-tab-content.cloud-hosting').addClass('active')

        return
    }

    if (serviceId === 'scraping' && categoryId === 'custom-scraping') {
        orderPrices.find('.order-prices-tab-content.custom-scraping').addClass('active')
        makeOrderPricesTabActive(orderPrices, categoryId, serviceId)

        return
    }

    orderPrices.find('.order-prices-tab-content.pricing-wrap').addClass('active')

    makeOrderPricesTabActive(orderPrices, categoryId, serviceId)
}

const updateProductFeatures = function (categoryId)
{
    const categories = window.categories;
    const category = categories[categoryId] !== undefined ? categories[categoryId] : categoryId;
    const productFeaturesElem = $('#product-features');

    productFeaturesElem.find('.product-features').removeClass('active');
    productFeaturesElem.find('[data-category="' + category + '"]').addClass('active');
}

/**
 * Handle the package change event
 *
 * @param event
 */
const onPackageChange = function(event)
{
    event.preventDefault()

    const $package = $(this)

    // Stop if the package is already active
    if ($package.hasClass('active')) {
        return
    }

    // Remove the old active package
    const $activePackage = $package.parents().find('.tab-wrap.active')
    $activePackage.removeClass('active')
    $activePackage.find('.tab-radio-input').removeAttr('checked')
    $activePackage.find('.radio-button-description').removeClass('active')

    // Mark the package as active
    $package.addClass('active')
    $package.find('.tab-radio-input').attr('checked', 'checked')
    $package.find('.radio-button-description').add('active')

    const serviceId = $package.data('service')
    let categoryId = $package.data('category')

    window.current_service = serviceId
    rangeSlider.setAttribute('data-category', categoryId)
    const buyNowBtn = $('.button-buy-now');

    updateOrderPricesTabsDetails(serviceId, categoryId)

    if (serviceId === 'web-hosting') {
        categoryId = 'cloud-hosting';
    }

    updateProductFeatures(categoryId)

    if (serviceId === 'web-hosting' || (serviceId === 'scraping' && categoryId === 'custom-scraping')) {
        buyNowBtn.removeClass('active');
        return;
    }

    if (!buyNowBtn.hasClass('active')) {
        buyNowBtn.addClass('active');
    }

    // Reset the slider bar
    $('.noUi-connects').removeAttr('style')

    updateProductDetails(serviceId, categoryId)

    createOrUpdateSlider(getSliderSteps(window.services[serviceId].products, categoryId))
}

/**
 * Handle the product category change event
 *
 * @param event
 */
const onProductCategoryChange = function(event)
{
    event.preventDefault()

    const $productCategory = $(this)

    const categoryId = $productCategory.data('category')
    const serviceId = $productCategory.data('service')

    rangeSlider.setAttribute('data-category', categoryId)
    window.current_service = serviceId

    updateOrderPricesTabsDetails(serviceId, categoryId)
    updateProductFeatures(categoryId)

    const buyNowBtn = $('.button-buy-now');

    if (serviceId === 'web-hosting' || (serviceId === 'scraping' && categoryId === 'custom-scraping')) {
        buyNowBtn.removeClass('active');
        return;
    }

    if (!buyNowBtn.hasClass('active')) {
        buyNowBtn.addClass('active');
    }

    createOrUpdateSlider(getSliderSteps(window.services[window.current_service].products, categoryId))
    updateProductDetails(serviceId, categoryId)
}

/**
 * Update the arrow position on window resize
 *
 * @return mixed
 */
const createBubbles = () => {
    const noUiOrigin = rangeSlider.querySelector('.noUi-origin')

    if (!noUiOrigin) {
        return
    }

    const sliderSteps = getSliderSteps(
        window.services[window.current_service].products,
        rangeSlider.getAttribute('data-category')
    )

    const category = sliderSteps.firstProduct.category.slug

    // Create top bubble
    const topBubble = document.createElement('div')
    topBubble.classList.add('noUi-bubble')
    topBubble.classList.add('noUi-bubble-top')
    topBubble.innerText = '$' + sliderSteps.firstProduct.price

    // Create bottom bubble
    const bottomBubble = document.createElement('div')
    bottomBubble.classList.add('noUi-bubble')
    bottomBubble.classList.add('noUi-bubble-bottom')

    const bottomBubbleTextWrapper = document.createElement('div')
    const bottomBubbleTitle = document.createElement('p')
    bottomBubbleTitle.classList.add('noUi-bubble-title')

    const bottomBubbleTitleNumber = document.createElement('span')
    bottomBubbleTitleNumber.classList.add('number')
    bottomBubbleTitleNumber.innerText = getBottomBubbleQuantity(
        category,
        (isTrafficCategory(category) ? sliderSteps.firstProduct.package.quantity : sliderSteps.range.min)
    )

    const bottomBubbleTitleText = document.createElement('span')
    bottomBubbleTitleText.classList.add('text')
    bottomBubbleTitleText.innerText = getBottomBubbleText(category)

    bottomBubbleTitle.append(bottomBubbleTitleNumber)
    bottomBubbleTitle.append(bottomBubbleTitleText)

    const bottomBubbleComment = document.createElement('p')
    bottomBubbleComment.classList.add('comment')

    setBottomBubbleComment(sliderSteps.firstProduct, category, bottomBubbleComment)

    bottomBubbleTextWrapper.append(bottomBubbleTitle)
    bottomBubbleTextWrapper.append(bottomBubbleComment)

    bottomBubble.append(bottomBubbleTextWrapper)

    noUiOrigin.append(topBubble)
    noUiOrigin.append(bottomBubble)
}

const getBottomBubbleQuantity = (slug, quantity) => {
    if (slug === 'webscraping' || slug === 'serp') {
        if (quantity <= 1000) {
            return quantity
        }

        if (quantity < 1000000) {
            return (quantity/1000) + 'K'
        }

        return (quantity/1000000) + 'M'
    }

    return quantity
}

const getBottomBubbleText = (slug) => {
    if (slug === 'webscraping') {
        return 'API Credits';
    }

    if (slug === 'serp') {
        return 'API Calls';
    }

    if (isTrafficCategory(slug)) {
        return 'TB';
    }

    return 'Proxies'
}

const isTrafficCategory = (slug) => {
    return ['basic-traffic', 'special-traffic', 'fast-rotating-traffic'].includes(slug);
}

/**
 * Handle the init slider event
 *
 */
const initSlider = () => {
    // Stop if no services
    if (!window.services) {
        return
    }

    // Stop if no range slider
    if (!rangeSlider) {
        return
    }

    // Create the slider instance
    createOrUpdateSlider(getSliderSteps(window.services[window.current_service].products, rangeSlider.getAttribute('data-category')))

    createBubbles()

    const $body = $('body')

    // Handle the package change event
    $body.on('click', '#packages-list .package', onPackageChange)

    $body.on('click', '#order-prices-root .order-prices-tabs-wrap', onProductCategoryChange)
}

export default function()
{
    initSlider()
}
